import { render, staticRenderFns } from "./cargarproductos.vue?vue&type=template&id=5d61131e"
import script from "./cargarproductos.vue?vue&type=script&lang=js"
export * from "./cargarproductos.vue?vue&type=script&lang=js"
import style0 from "./cargarproductos.vue?vue&type=style&index=0&id=5d61131e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports